var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg2FoldEmbryo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 23,
    viewBox: "0 0 18 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.2123 11.511C17.2188 5.24573 13.4057 0.162727 8.69548 0.157795C3.98523 0.152862 0.161507 5.22787 0.154946 11.4931C0.148385 17.7584 3.96147 22.8414 8.67172 22.8463C13.382 22.8513 17.2057 17.7763 17.2123 11.511Z",
    fill: "#F2F2F2",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2402 0.349609L8.77734 15.2991",
    stroke: "black",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.41517 8.39176C4.51447 8.13211 4.44632 7.86476 4.26294 7.79462C4.07956 7.72449 3.85041 7.87812 3.7511 8.13777C3.65179 8.39742 3.71994 8.66476 3.90332 8.7349C4.0867 8.80504 4.31586 8.65141 4.41517 8.39176Z",
    fill: "#B1337D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.87904 6.15835C5.97834 5.8987 5.91019 5.63136 5.72681 5.56122C5.54344 5.49109 5.31427 5.64472 5.21497 5.90437C5.11566 6.16402 5.18381 6.43137 5.36719 6.5015C5.55057 6.57164 5.77973 6.418 5.87904 6.15835Z",
    fill: "#FF8B5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.75745 6.7526C6.85676 6.49295 6.78861 6.2256 6.60523 6.15547C6.42185 6.08533 6.19269 6.23896 6.09338 6.49861C5.99408 6.75826 6.06223 7.02561 6.24561 7.09574C6.42899 7.16588 6.65815 7.01225 6.75745 6.7526Z",
    fill: "#FF8B5C"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.06031 10.3539C6.23903 9.75633 6.00202 9.15768 5.53093 9.01679C5.05985 8.87591 4.53308 9.24615 4.35436 9.84374C4.17564 10.4413 4.41265 11.04 4.88374 11.1809C5.35482 11.3218 5.88159 10.9515 6.06031 10.3539Z",
    fill: "#FF00FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.55445 5.29435C8.73317 4.69676 8.49616 4.0981 8.02508 3.95722C7.55399 3.81633 7.02722 4.18657 6.8485 4.78417C6.66978 5.38176 6.90679 5.98042 7.37788 6.1213C7.84896 6.26219 8.37573 5.89195 8.55445 5.29435Z",
    fill: "#71D1D1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.37438 8.97653C3.62483 8.66514 3.5875 8.21938 3.29101 7.98091C2.99451 7.74243 2.55111 7.80154 2.30066 8.11293C2.0502 8.42432 2.08753 8.87008 2.38403 9.10856C2.68053 9.34703 3.12392 9.28792 3.37438 8.97653Z",
    fill: "#800080"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.89369 8.50502C6.15557 8.19403 6.13622 7.74687 5.85048 7.50625C5.56474 7.26564 5.12082 7.32269 4.85894 7.63368C4.59706 7.94467 4.6164 8.39183 4.90214 8.63245C5.18788 8.87306 5.63181 8.81601 5.89369 8.50502Z",
    fill: "#00FFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.68311 11.1913C3.79614 10.5355 3.54633 9.94501 3.12512 9.87241C2.70392 9.7998 2.27083 10.2726 2.1578 10.9283C2.04476 11.5841 2.29458 12.1746 2.71578 12.2472C3.13699 12.3198 3.57007 11.847 3.68311 11.1913Z",
    fill: "#FBB03B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.77965 4.45065C5.0301 4.13926 4.99278 3.69351 4.69628 3.45503C4.39978 3.21655 3.95638 3.27566 3.70593 3.58705C3.45548 3.89845 3.4928 4.3442 3.7893 4.58268C4.0858 4.82116 4.52919 4.76204 4.77965 4.45065Z",
    fill: "#00FF00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.18688 11.7988C7.43733 11.4874 7.4 11.0416 7.10351 10.8032C6.80701 10.5647 6.36361 10.6238 6.11316 10.9352C5.8627 11.2466 5.90003 11.6923 6.19653 11.9308C6.49303 12.1693 6.93642 12.1102 7.18688 11.7988Z",
    fill: "#00FF00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.3719,
    height: 23,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg2FoldEmbryo);
export default __webpack_public_path__ + "static/media/2FoldEmbryo.82690d706b66cf11e921267b31a439b8.svg";
export { ForwardRef as ReactComponent };